let alertSequence = 0

export const state = () => ({
  alerts: [],
})

export const actions = {
  raiseAlert({ commit }, { message, state, details, autoHide }) {
    const id = `${Date.now()}-${alertSequence++}`
    if (!state) {
      state = 'success'
    }

    if (autoHide === undefined) {
      if (state === 'success') {
        autoHide = 1000
      } else {
        autoHide = 10000
      }
    }

    commit('addAlert', {
      message,
      state,
      details,
      id,
    })

    if (autoHide) {
      setTimeout(() => {
        commit('removeAlert', id)
      }, autoHide)
    }

    return id
  },
}

export const mutations = {
  addAlert(store, alert) {
    store.alerts.unshift(alert)
  },
  removeAlert(store, id) {
    store.alerts = store.alerts.filter((alert) => alert.id !== id)
  },
}

export const getters = {}
